var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSelectUpDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28616 8.25244C6.03572 7.9807 5.61241 7.96342 5.34067 8.21386C5.06892 8.46429 5.05165 8.8876 5.30209 9.15935L8.94658 13.1139L8.94667 13.114C9.52022 13.7365 10.4794 13.7365 11.0529 13.1141L11.053 13.1139L14.6979 9.15937C14.9483 8.88764 14.9311 8.46433 14.6594 8.21388C14.3876 7.96343 13.9643 7.98069 13.7139 8.25242L10.0689 12.2071L10.0688 12.2072C10.0414 12.237 10.0165 12.2427 9.99981 12.2427C9.98312 12.2427 9.95824 12.237 9.93083 12.2072L9.93074 12.2071L6.28616 8.25244Z",
    fill: "#52C564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectUpDownArrow);
export default __webpack_public_path__ + "static/media/icon_select_up_down_arrow.0ecfa31b.svg";
export { ForwardRef as ReactComponent };